import { ISecurityRoleDetail } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const securityRolesAdapter: EntityAdapter<ISecurityRoleDetail> = createEntityAdapter<ISecurityRoleDetail>({
	selectId: address => address.operator
});